module.exports = __webpack_public_path__ + "static/media/helloimlaurie-IG2.bc976fa4.PNG";